<template>
  <div class="general-dropdown" :style="{ width: dropdownlistWidth }">
    <div style="padding: 10px 0">
      <el-scrollbar ref='clickselect' wrap-class="clickselect-scroll_wrap" :class="{'entTypeWrap':field=='enttype'||field=='entstatus'}">
        <slot></slot>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
export default {
  props: ['value', 'querystring', 'field', 'multiple', 'total','width'],
  inject: ['select'],
  provide() {
    return {
      select: this
    };
  },
  data() {
    return {};
  },
  computed: {
    initial() {
      if (!this.querystring) return null;
      if (this.querystring.indexOf('}') != -1) {
        let form = JSON.parse(this.querystring);
        if (form.filter) {
          form.filter = JSON.parse(form.filter);
        }
        if (form.filter[this.field] && form.filter[this.field]!='0' && form.filter[this.field].length > 0) {
          return form.filter[this.field];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    dropdownlistWidth () {
      if(this.width === 'auto') {
        return 'auto'
      }
      let width = 261
      if(this.width > 0) {
        width = this.width
      }
      return width + 'px'
    }
  },
  methods: {
    onSelect(val) {
      if (this.multiple) {
        const index = this.value.indexOf(val);
        if (index != -1) {
          const clone = this.cloneDeep(this.value);
          this.$emit('input', clone);
          this.$emit('change', clone);
        } else {
          if (val == 'all') {
            this.$emit('input', []);
            this.$emit('change', []);
          } else {
            if (this.value.length == 1 && this.value.indexOf('all') != -1) {
              this.$emit('input', [val]);
              this.$emit('change', [val]);
              return;
            }
            if (this.value.length == this.total - 1) {
              this.$emit('input', []);
              this.$emit('change', []);
            } else {
              this.$emit('input', this.value.concat([val]));
              this.$emit('change', this.value.concat([val]));
            }
          }
        }
      } else {
        this.$emit('input', val);
        this.$emit('change', val);
      }
      this.select.visible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.general-dropdown {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}
</style>





// WEBPACK FOOTER //
// src/components/clickSelect/generalSelect.vue